import React from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Radio from '@material-ui/core/Radio'
import Avatar from '@material-ui/core/Avatar'

export default ({ selected, label, image, labelId, onClick }) => (
	<ListItem button onClick={onClick}>
        <Avatar src={image} />
        <ListItemText primary={label} id={labelId} />
        <Radio checked={selected} inputProps={{ 'aria-labelledby': labelId }} />
    </ListItem>
)


// WEBPACK FOOTER //
// ./src/components/Filter/BasemapRadio.js